export default __webpack_public_path__ + "static/media/Usuario_on.a250ec2d.svg";